import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=13d941fd&scoped=true"
import script from "./OrganizationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d941fd",
  null
  
)

export default component.exports